<ng-container *ngIf="!!get">
    <tt-divider ttRememberId="requisitionsimplified.boxes">
        <tt-divider-rows ttId="requisitionsimplified.rows">
            <tt-divider-pane ttId="requisitiondel" ttSize="50">
                <tt-divider-columns ttId="requisitiondel.columns">
                    <tt-divider-pane ttId="filters" ttSize="25">
                        <tt-card>
                            <tt-requisition-simplified-filters [get]="get" [requisitionDelGrid]="requisitionDelGrid" (submit)="readRequisitionDelGrid()"></tt-requisition-simplified-filters>
                        </tt-card>
                    </tt-divider-pane>
                    <tt-divider-pane ttId="requisitiondelgrid" ttSize="75">
                        <tt-grid
                            *ngIf="!!requisitionDelGrid"
                            [(ttOptions)]="requisitionDelGrid"
                            ttRowSelection="single"
                            (ttOnRead)="onRequisitionDelGridRead()"
                            (ttOnRowSelected)="onRequisitionDelSelected($event)"
                            (ttRowDataChange)="onRequisitionDelDataChanged($event)"
                        ></tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider-pane>
            <tt-divider-pane ttId="requisition" ttSize="50">
                <tt-grid *ngIf="!!requisitionGrid && get.selected_requisitiondel_keyno !== null" [(ttOptions)]="requisitionGrid"></tt-grid>
            </tt-divider-pane>
        </tt-divider-rows>
    </tt-divider>
    <tt-card *ngIf="get.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</ng-container>
